import { jsx as _jsx } from "react/jsx-runtime";
import { FeedbackMessage } from "@gemini/ui";
import { useContactContext, useContactSections } from "@/contexts/contact";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const descriptionCTATestId = "cdp-description-cta";
export const DescriptionCTA = () => {
    var _a;
    const { toggleModal } = useContactContext();
    const isPreviewMode = useIsPreviewMode();
    const isProject = useIsNewBuildProject();
    const { t } = useI18n();
    const isPrivateOwner = (_a = useContactSections()) === null || _a === void 0 ? void 0 : _a.contactCard.isPrivateOwner;
    const providerText = isPrivateOwner
        ? t("contact.form.owner_provider_text")
        : t("contact.form.agent_provider_text");
    const btnText = isProject
        ? t("contact.form.project.email")
        : t("energy.description.fallback.cta").replace("{value}", providerText.toLowerCase());
    return (_jsx(FeedbackMessage, { testId: descriptionCTATestId, variant: "info", startButtonProps: {
            children: btnText,
            onPress: () => {
                toggleModal({
                    av_zone: "description_notavailable",
                    legacyTrackingInfos: "detail-bottom",
                });
            },
            isDisabled: isPreviewMode,
        }, children: t("description.fallback.text_v2").replace("{value}", providerText) }));
};
